var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "color000 svgShape",
    transform: "translate(0 -1020.362)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#777E89",
    d: "m5 1033.362 7-6m-1 20-6-10m15-1 7-7m-2 13-5-3m-14-3 11 1m-2.5 11.5 10.5-3.5m-6.5-20.6 7.5 1.1m3 3.5-1 13",
    className: "colorStroke2b4255 svgStroke"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 1025.362,
    r: 3.5,
    fill: "#25b39e",
    stroke: "#25b39e",
    strokeDashoffset: 3.2,
    strokeMiterlimit: 0.6,
    color: "#000",
    overflow: "visible",
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    },
    className: "color25b39e svgShape colorStroke25b39e svgStroke"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    },
    cx: 4,
    cy: 1035.362,
    r: 2.5,
    fill: "#25b39e",
    stroke: "#25b39e",
    strokeDashoffset: 3.2,
    strokeMiterlimit: 0.6,
    className: "color25b39e svgShape colorStroke25b39e svgStroke",
    color: "#000",
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    },
    cx: 12.5,
    cy: 1048.862,
    r: 2,
    fill: "#FB9678",
    stroke: "#FB9678",
    strokeDashoffset: 3.2,
    strokeMiterlimit: 0.6,
    className: "colorf05542 svgShape colorStrokef05542 svgStroke",
    color: "#000",
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 1037.862,
    r: 2,
    fill: "#f8b84e",
    stroke: "#f8b84e",
    strokeDashoffset: 3.2,
    strokeMiterlimit: 0.6,
    color: "#000",
    overflow: "visible",
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    },
    className: "colorf8b84e svgShape colorStrokef8b84e svgStroke"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    },
    cx: 26.5,
    cy: 1043.862,
    r: 2,
    fill: "#4bbfeb",
    stroke: "#4bbfeb",
    strokeDashoffset: 3.2,
    strokeMiterlimit: 0.6,
    className: "color4bbfeb svgShape colorStroke4bbfeb svgStroke",
    color: "#000",
    overflow: "visible"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 1027.362,
    r: 2.5,
    fill: "#FB9678",
    stroke: "#FB9678",
    strokeDashoffset: 3.2,
    strokeMiterlimit: 0.6,
    color: "#000",
    overflow: "visible",
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    },
    className: "colorf05542 svgShape colorStrokef05542 svgStroke"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.e3c533749a184f0298c9bd9b42fe0021.svg";
export { ForwardRef as ReactComponent };